import Api from '../Base'

class PostShelf extends Api {
  requestUrl = '/api/Shelf'

  method = 'POST'
}

export default PostShelf
